module.exports = __webpack_public_path__ + "static/media/image.500f6f5d.png";